import { observable, action, computed, autorun } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
import directus from '../utils/directus'


class TranslationStore {

  @observable t
  @observable locale
  @observable languages
  @observable loaded

  constructor() {
    this.t = {}
    this.loaded = false
     
    // Load active language
    // default to 'en'
    this.languages = ['de', 'en', 'it']
    this.locale = 'en'
    

    //Try to load cookie
    const cookieLang = this.getCookie('lang')

    if(cookieLang && this.languages.includes(cookieLang)) {
      this.locale = cookieLang
    } else {
      /** Try to detect language from browser */
      try {
        const browserLang = navigator.language.slice(0,2)

        if (this.languages.includes(browserLang)) {
          this.locale = browserLang
        }
      } catch (err) {

      }
    }  
    
    this.setCookie('lang', this.locale, 365)
  }

  @action setTranslations (translations) {
    this.t = translations
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  async setLanguage (lang) {
    if (this.languages.includes(lang)) {
      this.locale = lang
      this.setCookie('lang', this.locale, 365)
      // await this.loadTranslations()        // For some reason react explodes if we do that lol
      location.reload()                       // So instead we do an old fashioned page reload ¯\_(ツ)_/¯
    }
  }

  injectTranslations (data) {    
    const handle = (item) => {
      if (item === null || item === undefined) {
        return null
      } else if (typeof item === 'object') {
        for (const i in item) {
          item[i] = handle(item[i])
        }
  
        if (item.translations) {
          let trans
  
          if (item.translations.length === 0) {
            return null
          }

          // Try fetching current locale
          for (const translation of item.translations) {
            if (translation && translation.languages_code === this.locale || translation.languages_id === this.locale) {
              trans = translation
            }
          }

          // If current locale not available, try fetching default locale
          if (!trans) {
            for (const translation of item.translations) {
              if (translation && translation.languages_code === 'en' || translation.languages_id === 'en') {
                trans = translation
              }
            }
          }
  
          // If no matching translation could be found until here, just select to first
          if (!trans) {
            trans = item.translations[0]
          }
  
          // remove unused / overlapping values
          delete trans.id
          delete trans.languages_code
          delete trans.languages_id
  
          item = { ...item, ...trans } // inject first transaltion item in current item
          delete item.translations // remove translations property from item
        }
  
        return item
      } else if (Array.isArray(item)) {
        return item.map(i => handle(i))
      } else {
        return item
      }
    }
  
    return handle(data)
  }

  async loadTranslations () {
    try {
      const data = await directus.get('items/global_texts?fields=*.*&limit=-1')
      const result = this.injectTranslations(data.data)

      const translations = {}
      

      result.data.forEach((text) => {
        if (text && text.key && text.text) {
          translations[text.key] = text.text
        }
      })

      this.setTranslations(translations)
      this.loaded = true

      // console.log('TRANSLATION INIT', this.t)
    } catch (err) {
      console.log(err)

      setTimeout(() => {
        this.loadTranslations()
      }, 200);
      // error({ statusCode: 500, message: 'Internal error' })
    }
  }

  getText (key) {
    if (key in this.t) {
      return this.t[key]
    } else {
      return ''   //return '[' + key + ']'
    }
  }
}

const store = new TranslationStore()
export default store

autorun(() => {
  if(!store.loaded)
    store.loadTranslations()
})



// WEBPACK FOOTER //
// /src/stores/TranslationStore.js